import React from "react";
import { RadioQuestion } from "valuations-journey";

export const Question = ({ useSameDetailsId, setUseSameDetailsId }) => {
  return (
    <RadioQuestion
      question={""}
      answers={[
        {
          id: 1,
          label: "Yes",
          tooltip: "Yes",
          imageQuantityRequired: 0
        },
        {
          id: 2,
          label: "No - start a fresh valuation",
          tooltip: "No",
          imageQuantityRequired: 0
        }
      ]}
      value={useSameDetailsId}
      onChange={(id) => setUseSameDetailsId(Number(id))}
    />
  );
};
